import { UnitEconomicsCalculator } from '@/components/calculator/UnitEconomicsCalculator'
import { PageSeo } from '@/components/seo/PageSeo'
import { sitePages } from '@/config/pages'

/** Unlisted: shared by link from the partner briefing, noindex, not in the sitemap. */
export const UnitEconomicsCalculatorPage = () => (
  <>
    <PageSeo page={sitePages.unitEconomics} />
    <UnitEconomicsCalculator />
  </>
)
